import React from 'react';
import { bindActionCreators } from 'redux';
import * as ReactRedux from 'react-redux';
import { closeFreeWriteUploadModal } from 'Modals/ModalActions';
import {
  convertToCustomTemplateFromDocumentType,
} from 'ConvertToCustomTemplate';
import setUploadRedirectURL from 'Upload/UploadActions';
import store from 'store';
import UploadDocumentBody from './UploadDocumentBody';

const UploadActions = {
  closeFreeWriteUploadModal,
  setUploadRedirectURL,
};

const mapStateToProps = ({ UploadHandler }) => (
  {
    redirectURL: UploadHandler.redirectURL,
    newUploadDocumentType: UploadHandler.newUploadDocumentType,
    newUploadSessionHash: UploadHandler.newUploadSessionHash,
    newUploadSessionKey: UploadHandler.newUploadSessionKey,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...UploadActions,
    convertToCustomTemplateFromDocumentType,
  }, dispatch)
);

const UploadDocumentBodyContainer = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadDocumentBody);

const ConnectedUploadDocumentBodyContent = props => (
  <ReactRedux.Provider store={store}>
    <UploadDocumentBodyContainer {...props} />
  </ReactRedux.Provider>
);

if (window.FormSwift && window.FormSwift.React) {
  const addedActions = Object.assign(
    {},
    UploadActions,
    window.FormSwift.React.actions,
  );
  window.FormSwift.React.actions = addedActions;
} else {
  window.FormSwift = {
    React: {
      store,
      actions: UploadActions,
    },
  };
}

export default ConnectedUploadDocumentBodyContent;



// WEBPACK FOOTER //
// ./src-react/Modals/content/UploadDocumentBodyContent/index.jsx